import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-error-dialogue',
    templateUrl: './error-dialogue.component.html',
    styleUrls: ['./error-dialogue.component.scss'],
    standalone: false
})
export class ErrorDialogueComponent {
  displayDialogue = false;
  @Input() feildName;
  @Input()
  set showError(v) {
    if (v) {
      this.displayDialogue = true;
    } else {
      this.displayDialogue = false;
    }
  }
}
